import React, { useMemo } from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import {
  Box,
  makeStyles,
  TextField,
  Theme,
  Typography,
} from '@material-ui/core'
import { FieldRenderProps } from 'react-final-form'
import { Record, useGetList, useTranslate } from 'ra-core'

import { API_ENDPOINTS } from 'src/api'
import { isPrintable } from '@obvious.tech/util/string'

const useStyles = makeStyles((theme: Theme) => ({
  input: {
    marginBottom: theme.spacing(1),
  },
}))

const RoleTemplateSelect = ({
  input,
  meta,
}: FieldRenderProps<Record>): JSX.Element => {
  const classes = useStyles()
  const translate = useTranslate()

  const { data, loading } = useGetList(
    API_ENDPOINTS.ROLE_TEMPLATE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {} as any,
  )

  const helperText = useMemo((): string | undefined => {
    const error = meta.error

    if (error instanceof Error) return translate(error.message)
    if (typeof error === 'string') return translate(error)
  }, [meta.error, translate])

  return (
    <Autocomplete
      options={Object.values(data ?? {})}
      className={classes.input}
      value={input.value ?? null}
      onChange={(_, record) => input.onChange(record)}
      onBlur={input.onBlur}
      loading={loading}
      loadingText='Loading...'
      getOptionLabel={record => record.name ?? ''}
      renderOption={record => (
        <Box>
          <Typography>{record.name}</Typography>
          {isPrintable(record.description) && (
            <Typography variant='body2'>{record.description}</Typography>
          )}
        </Box>
      )}
      renderInput={params => (
        <TextField
          {...params}
          name={input.name}
          helperText={helperText}
          error={
            meta.touched === true &&
            typeof helperText === 'string' &&
            helperText.trim() !== ''
          }
          label='Role template'
        />
      )}
    />
  )
}

export default RoleTemplateSelect
